import { Box, Heading, Icon, Link, Stack, Text, VStack } from '@chakra-ui/react'
import { UserSignupEmailCaptureForm } from '@src/components/sco/Account/UserSignupEmailCaptureForm'
import { ButtonLink, ButtonLinkProps } from '@src/components/sco/ButtonLink.tsx'
import { UserAccessGateCTAProps } from '@src/components/sco/UserAccessGate'
import { NextLink } from '@src/components/sco/utilities/NextLink'
import { useCurrentUser } from '@src/hooks/useCurrentUser'
import { usePathname } from 'next/navigation'
import React from 'react'

export const BoxedCardCTA = (props: UserAccessGateCTAProps) => {
  const { currentUser } = useCurrentUser()
  const pathname = usePathname()

  return (
    <Box
      bgColor={'colorPalette.container'}
      borderRadius={'1em'}
      boxShadow={'0 0.25em 1em rgba(0,0,0,.5)'}
      padding={'2em 2em'}
      textAlign={'center'}
      width={'full'}
      {...(props.boxProps || {})}
    >
      <VStack align={'center'} gap={2} justify={'center'} margin={'0 auto'}>
        {props.icon && (
          <Icon asChild height={'1.5em'} width={'1.5em'}>
            <props.icon />
          </Icon>
        )}
        <Box>
          <Heading flexGrow={1} fontSize={'18px'}>
            {props.title ?? "You don't have access to this yet."}
          </Heading>

          {props.subtitle && <Text marginY={'0.5em'}>{props.subtitle}</Text>}
        </Box>

        {props.emailCaptureProps && (
          <UserSignupEmailCaptureForm
            {...props.emailCaptureProps}
            containerProps={{
              background: 'transparent',
              border: 0,
              borderRadius: 0,
              boxShadow: 'none',
              padding: 0,
              ...(props.emailCaptureProps.containerProps || {}),
            }}
          />
        )}

        {props.buttons?.length && (
          <Stack direction={['column', 'column', 'row']} gap={'0.67em'}>
            {props.buttons.map((buttonProps, idx) => (
              <ButtonLink
                key={idx}
                href={buttonProps?.href || '#'}
                size={['sm', 'md']}
                variant={'cta'}
                _hover={{
                  transform: 'scale(1.025)',
                }}
                {...((buttonProps as ButtonLinkProps) || {})}
              >
                {buttonProps?.children || buttonProps?.title}
              </ButtonLink>
            ))}
          </Stack>
        )}

        {!props.hideLoginLink && !currentUser?.isGuest && (
          <>
            <Text fontSize={'0.8em'}>
              {'Already a member?'}{' '}
              <Link asChild variant={'underline'}>
                <NextLink href={`${pathname}?prompt=login`}>Login</NextLink>
              </Link>
            </Text>
          </>
        )}
      </VStack>
    </Box>
  )
}
